import { render, staticRenderFns } from "./class-session-form.vue?vue&type=template&id=10de899a"
import script from "./class-session-form.vue?vue&type=script&lang=js"
export * from "./class-session-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports